export default __webpack_public_path__ + "static/media/defaultBanner.167a3d0e.png";